import { Size } from '../Size';
import { Crop, CropLike } from './Crop';

export class PxCrop implements Crop {
  public unit = 'px' as const;
  public constructor(public x: number, public y: number, public width: number, public height: number) {}

  public static from({ x, y, width, height }: CropLike): PxCrop {
    return new PxCrop(x, y, width, height);
  }

  public toPx(_elementSize: Size): PxCrop {
    return this;
  }
}
